import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-ribbon-cancel-dialog',
  templateUrl: './ribbon-cancel-dialog.component.html',
  styleUrls: ['./ribbon-cancel-dialog.component.scss']
})
export class RibbonCancelDialogComponent implements OnInit {

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

}
